import { Component, OnInit } from '@angular/core';
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { LoyaltyCatalogGiftAssignedService } from 'app/services/loyalty/loyalty-catalog-gift-assigned.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';

@Component({
  selector: 'app-loyalty-catalog-gift-assigned',
  templateUrl: './loyalty-catalog-gift-assigned.component.html',
  styleUrls: ['./loyalty-catalog-gift-assigned.component.css']
})
export class LoyaltyCatalogGiftAssignedComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  selectFilter = KontableComponent.SelectFilter;

  storeId: number;
  headId: number;
  tableFields: any;
  findObject: any;

  //Dropdown Filtri per ricerca nella table
  reservationTypes: Array<{value: string, label: string}> = [];
  giftOption: Array<{value: string, label: string}> = [];
  catalogOption:Array<{value: string, label: string}> = [];
  acmTypes: Array<{value: string, label: string}> = [];
  storeOption: Array<{value: string, label: string}> = [];

  reservationState: string;

  constructor(
    public giftAssignedService: LoyaltyCatalogGiftAssignedService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    private giftService: LoyaltyGiftReservationService
    ) { }

  ngOnInit() {

    //Recupero lo store id dalla URL
    this.storeId = this.activatedroute.snapshot.params['storeId'];
    this.giftAssignedService.setStoreId(this.storeId);

    //Recupero la reservation head id dalla URL
    this.headId= this.activatedroute.snapshot.params['reservationHeadId'];
    this.giftAssignedService.setHeadId(this.headId);

    this.giftAssignedService.getCatlogGiftItemFields().subscribe( res=> this.tableFields = res)


    /**
     * Chiamata per inserire i valori dei filtri nei dropdown
     * controllo prima se i valori esistono già nei dropdown
     * se non esistono vengono inseriti
     */
    this.giftAssignedService.getRecordList().subscribe(res =>{

      res.forEach(el => {

        this.findObject = null;
        this.findObject = this.giftOption.find(gift => gift.value == el.gift_code);

        if(!this.findObject){
          this.giftOption.push({value: el.gift_code, label: el.gift_code + ' - ' + el.gift_description});
        }


        this.findObject = null;
        this.findObject = this.catalogOption.find(catalog => catalog.value == el.catalog_code);

        if(!this.findObject){
        this.catalogOption.push({value: el.catalog_code, label: el.catalog_code + ' - ' + el.catalog_description});
        }

        this.findObject = null;
        this.findObject = this.acmTypes.find(acm => acm.value == el.acm_code);

        if(!this.findObject){
        this.acmTypes.push({value: el.acm_code, label: el.acm_code + ' - ' +  el.acm_description});
        }

        this.findObject = null;
        this.findObject = this.storeOption.find(store => store.value == el.store_id);

        if(!this.findObject){
        this.storeOption.push({value: el.store_id, label: el.store_name});
        }
      });

    })

  }

  /**
   * Metodo che viene richiamato nell'html dal bottone affianco ad ogni record
   * ci porta nella pagina relativa alla reervation del cliente tramite il suo Id
   * @param customerId l'id del Cliente
   * @param cardId il numero di carta di un Cliente
   * @param acmId l'id dell'accumulatore del Catalogo
   */
  redirectReservation($event){
    sessionStorage.setItem('customer', `${$event.cust_host_code} - ${$event.cust_name} ${$event.cust_surname}`);
    sessionStorage.setItem('acmCode', $event.acm_code);
    sessionStorage.setItem('acmDescription', $event.acm_description);
    sessionStorage.setItem('cardNo', $event.cust_card_number);
    if($event.gift_status >= 5){
      this.reservationState = 'closed';
    }else{
      this.reservationState = 'active';
    }

    this.router.navigate([`loyalty/reservations/${$event.customer_id}/${$event.cust_card_id}/${$event.acm_id}/${this.reservationState}`])
  }
}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-assigned/loyalty-catalog-gift-assigned.component.ts